export default __webpack_public_path__ + "static/media/edit.202367ac.svg";